var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoPass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "black",
    fillOpacity: 1,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M0.693333 1.65455L8 0L15.3067 1.65455C15.5082 1.70303 15.6741 1.81212 15.8044 1.98182C15.9348 2.15152 16 2.33939 16 2.54545V11.6182C16 12.5394 15.7896 13.4 15.3689 14.2C14.9481 15 14.3644 15.6545 13.6178 16.1636L8 20L2.38222 16.1636C1.63555 15.6545 1.05185 15 0.631111 14.2C0.210368 13.4 0 12.5455 0 11.6364V2.54545C0 2.33939 0.0651845 2.15152 0.195556 1.98182C0.325927 1.81212 0.491851 1.70303 0.693333 1.65455Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPass);
export default __webpack_public_path__ + "static/media/ico-pass.e0e8543a.svg";
export { ForwardRef as ReactComponent };